(function () {
  'use strict';

  // Contenedor de la app de personalización en este tema.
  var APP_SEL = '.gpo-container';

  // Botones que agregan al carrito, incluido el clon de la app.
  var ATC_SEL = '[type="submit"], [name="add"], .gpo-clone-atc-button';

  var interaccion = false;
  var enviando = false;

  // ------------------------------------------------------------ detección

  // Solo cuentan los eventos reales del usuario: isTrusted descarta los
  // que genera la propia app al montar sus valores por defecto.
  ['pointerdown', 'change', 'input', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!e.isTrusted) return;

      var el = e.target;
      if (!el || !el.closest) return;
      if (el.closest(ATC_SEL)) return;

      if (el.closest(APP_SEL)) {
        interaccion = true;
        return;
      }

      if (el.name && el.name.indexOf('properties[') === 0 && !el.dataset.mtmAuto) {
        interaccion = true;
      }
    }, true);
  });

  // Criterio único compartido con hv-personalizacion-gate, que marca
  // data-hv-armed en el <html> cuando el cliente abre el personalizador.
  function personalizado() {
    if (interaccion) return true;
    return document.documentElement.getAttribute('data-hv-armed') === 'true';
  }

  function reiniciar() {
    interaccion = false;
    document.documentElement.removeAttribute('data-hv-armed');
    document.querySelectorAll('[data-mtm-auto]').forEach(function (i) { i.remove(); });
  }

  window.addEventListener('havoc:gpo:init', reiniciar);
  document.addEventListener('shopify:section:load', reiniciar);

  // ------------------------------------------------------------- inyección

  function camposApp(form) {
    return Array.prototype.filter.call(form.elements, function (el) {
      return el.name && el.name.indexOf('properties[') === 0 && !el.dataset.mtmAuto;
    });
  }

  function inyectar(form) {
    var formId = form.getAttribute('id');
    if (!formId) return false;

    var holder = document.querySelector('[data-mtm-specs]');
    if (!holder) return false;

    var specs;
    try { specs = JSON.parse(holder.textContent); } catch (e) { return false; }
    if (!Array.isArray(specs) || !specs.length) return false;

    // Un campo deshabilitado no entra en el FormData: así los valores por
    // defecto de la app no viajan al carrito.
    camposApp(form).forEach(function (el) {
      if (!el.disabled) {
        el.disabled = true;
        el.dataset.mtmOff = 'true';
      }
    });

    document.querySelectorAll('[data-mtm-auto]').forEach(function (i) { i.remove(); });

    function add(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.dataset.mtmAuto = 'true';
      input.setAttribute('form', formId);
      holder.parentNode.insertBefore(input, holder);
    }

    specs.forEach(function (s) { add('properties[' + s.label + ']', s.value); });
    add('properties[_mtm_default]', 'true');

    return true;
  }

  function restaurar() {
    document.querySelectorAll('[data-mtm-off]').forEach(function (el) {
      el.disabled = false;
      delete el.dataset.mtmOff;
    });
  }

  // --------------------------------------------------------------- envío

  // Replica lo que hace <product-form> del tema, para que el cajón, el
  // contador y el aviso se comporten igual que en cualquier otro producto.
  function enviar(form, boton) {
    if (enviando) return;
    enviando = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    if (boton) boton.setAttribute('aria-busy', 'true');

    var secciones = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: secciones }
    }));

    var fd = new FormData(form);
    fd.set('sections', Array.from(secciones).join(','));

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        restaurar();
        if (boton) boton.removeAttribute('aria-busy');
        enviando = false;

        if (!res.ok) {
          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: { message: res.data.message || res.data.description, tone: 'error' }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return;
        }

        var items = res.data.items || [res.data];

        return fetch(root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            form.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: items, cart: cart }
            }));

            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cart }
            }));

            var cfg = window.themeVariables || {};
            var tipo = cfg.settings && cfg.settings.cartType;

            if (tipo === 'message') {
              var plantilla = (cfg.strings && cfg.strings.addedToCart) || '{{product_title}}';
              document.dispatchEvent(new CustomEvent('toast:show', {
                detail: {
                  message: plantilla.replace('{{product_title}}', (items[0] && items[0].title) || '')
                }
              }));
            }
          });
      })
      .catch(function (err) {
        restaurar();
        if (boton) boton.removeAttribute('aria-busy');
        enviando = false;
        console.error('mtm-specs: fallo el envio', err);
      });
  }

  // ------------------------------------------------------------- listeners

  function nuestro(e) {
    if (!e.isTrusted || !e.target.closest) return null;
    var btn = e.target.closest(ATC_SEL);
    if (!btn) return null;
    if (personalizado()) return null;
    if (!document.querySelector('[data-mtm-specs]')) return null;

    var form = btn.closest('form[action*="/cart/add"]')
            || document.querySelector('form[action*="/cart/add"]');
    if (!form || !form.getAttribute('id')) return null;

    return { btn: btn, form: form };
  }

  // La app intercepta el botón en varias capas y abre su panel. Hay que
  // detenerla en las tres para que no se vea el salto.
  ['pointerdown', 'mousedown', 'click'].forEach(function (tipo) {
    window.addEventListener(tipo, function (e) {
      var ctx = nuestro(e);
      if (!ctx) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (tipo !== 'click') return;

      if (inyectar(ctx.form)) enviar(ctx.form, ctx.btn);
    }, true);
  });

  // Respaldo por si el envío llega como submit del formulario.
  window.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form || !form.getAttribute('id')) return;
    if (personalizado()) return;
    if (!document.querySelector('[data-mtm-specs]')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (inyectar(form)) enviar(form, null);
  }, true);

  // Diagnóstico desde consola: window.__mtmEstado()
  window.__mtmEstado = function () {
    return {
      interaccion: interaccion,
      armadoGate: document.documentElement.getAttribute('data-hv-armed') === 'true',
      personalizado: personalizado(),
      contenedorApp: !!document.querySelector(APP_SEL),
      especificaciones: !!document.querySelector('[data-mtm-specs]'),
      botonClonado: !!document.querySelector('.gpo-clone-atc-button')
    };
  };
})();